module.exports = __webpack_public_path__ + "img/f3_1.3800f04a.png";